import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {VehicleType} from "../../../commons/types/vehicle.type";
import {LogisticsVehicleStatusType} from "../../types/logistics-vehicle-status.type";

export class LogisticsVehicleSelectCtrl implements IController {

  selectedId: any;
  options: any;
  optionIds: any;
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  isRequired: boolean;
  isStandAlone: boolean;
  vehicleTypes: VehicleType[];
  vehicleTypeIds: string[];
  status: LogisticsVehicleStatusType;
  branchIds: string[];
  onChange: Function;

  private logisticsVehiclesRef: any;
  public selectedLogisticsVehicle: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $logisticsVehicle) {
    this.logisticsVehiclesRef = this.$logisticsVehicle();
  }

  $onInit() {
    this._setSelectedLogisticsVehicle();
  };

  $onChanges(changes) {
    if (
      (changes.vehicleTypes && !changes.vehicleTypes.isFirstChange()) ||
      (changes.vehicleTypeIds && !changes.vehicleTypeIds.isFirstChange()) ||
      (changes.status && !changes.status.isFirstChange()) ||
      (changes.selectedId && !changes.selectedId.isFirstChange())
    ) {
      this._setSelectedLogisticsVehicle();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const vehicleTypesRef = this.vehicleTypes;
    const vehicleTypeIdsRef = this.vehicleTypeIds;
    const statusRef = this.status;
    const branchIdsRef = this.branchIds;
    const isStandAloneRef = this.isStandAlone;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'branch-ids="ctrl.branchIdsRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'logistic-vehicle';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.branchIdsRef = branchIdsRef;
        this.queryMapRef = {
          isStandAlone: isStandAloneRef,
          vehicleTypes: vehicleTypesRef,
          vehicleTypeIds: vehicleTypeIdsRef,
          status: statusRef
        }
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({logisticsVehicle: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const logisticsVehicle = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({logisticsVehicle: logisticsVehicle, id: selectedId});
            panel.destroy();
          } else {
            this.logisticsVehiclesRef.$asyncValues([selectedId])
              .then((logisticsVehicles) => {
                this.onChange({logisticsVehicle: logisticsVehicles[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({logisticsVehicle: undefined, id: undefined});
  }

  private _setSelectedLogisticsVehicle() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedLogisticsVehicle = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.logisticsVehiclesRef.$asyncValues([this.selectedId])
          .then((logisticsVehicles) => {
            this.selectedLogisticsVehicle = _.orderBy(logisticsVehicles, ['name'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedLogisticsVehicle = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedLogisticsVehicle, 'name', '');
  }


}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehicleSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      isStandAlone: '<?',
      vehicleTypes: '<?',
      vehicleTypeIds: '<?',
      status: '<?',
      branchIds: '<?',
      onChange: '&'
    },
    template: require('./logistics-vehicle-select.html').default,
    controller: LogisticsVehicleSelectCtrl
  });
